export default __webpack_public_path__ + "static/google-play-pt-badge-673427c7365146f43d7ed801fadac83e.png";